import React from 'react';


export const IconHome = ({ className }) => (<i className={`fi fi-rr-home ${className || ''}`}></i>);
export const IconNewspaper = ({ className }) => (<i className={`fi fi-rr-journal-alt ${className || ''}`}></i>);
export const IconUser = ({ className }) => (<i className={`fi fi-rr-user ${className || ''}`}></i>);
export const IconBookOpen = ({ className }) => (<i className={`fi fi-rr-book-open-cover ${className || ''}`}></i>);
export const IconSearch = ({ className }) => (<i className={`fi fi-rr-search ${className || ''}`}></i>);
export const IconDonate = ({ className }) => (<i className={`fi fi-rr-donate ${className || ''}`}></i>); // Generic donate
export const IconCash = ({ className }) => (<i className={`fi fi-rr-wallet ${className || ''}`}></i>);
export const IconActivity = ({ className }) => (<i className={`fi fi-rr-pulse ${className || ''}`}></i>);
export const IconUsers = ({ className }) => (<i className={`fi fi-rr-users-alt ${className || ''}`}></i>);
export const IconCart = ({ className }) => (<i className={`fi fi-rr-shopping-cart ${className || ''}`}></i>);
export const ShoppingCartIcon = ({ className }) => (<i className={`fi fi-rr-shopping-cart ${className || ''}`}></i>); // Alias for IconCart

export const IconHeart = ({ className }) => (<i className={`fi fi-rr-heart ${className || ''}`}></i>); // Outline heart
export const IconHeartFilled = ({ className }) => (<i className={`fi fi-sr-heart ${className || ''}`}></i>); // Solid heart

export const IconBookmark = ({ className }) => (<i className={`fi fi-rr-bookmark ${className || ''}`}></i>);
export const IconBookmarkFilled = ({ className }) => (<i className={`fi fi-sr-bookmark ${className || ''}`}></i>);

export const IconShare = ({ className }) => (<i className={`fi fi-rr-share ${className || ''}`}></i>);
export const IconPlusCircle = ({ className }) => (<i className={`fi fi-rr-add ${className || ''}`}></i>);
export const IconMinusCircle = ({ className }) => (<i className={`fi fi-rr-minus-circle ${className || ''}`}></i>);
export const IconPlayCircle = ({ className }) => (<i className={`fi fi-rr-play-circle ${className || ''}`}></i>);
export const IconPauseCircle = ({ className }) => (<i className={`fi fi-rr-pause-circle ${className || ''}`}></i>);

export const IconChevronLeft = ({ className }) => (<i className={`fi fi-rr-angle-left ${className || ''}`}></i>);
export const IconChevronRight = ({ className }) => (<i className={`fi fi-rr-angle-right ${className || ''}`}></i>);
export const IconChevronDown = ({ className }) => (<i className={`fi fi-rr-angle-down ${className || ''}`}></i>);
export const IconRefresh = ({ className }) => (<i className={`fi fi-rr-refresh ${className || ''}`}></i>);

export const IconUserCircle = ({ className }) => (<i className={`fi fi-rr-circle-user ${className || ''}`}></i>); 
export const IconInbox = ({ className }) => (<i className={`fi fi-rr-inbox ${className || ''}`}></i>);
export const IconSettings = ({ className }) => (<i className={`fi fi-rr-settings ${className || ''}`}></i>);
export const IconHelp = ({ className }) => (<i className={`fi fi-rs-interrogation ${className || ''}`}></i>);
export const IconLogout = ({ className }) => (<i className={`fi fi-rr-sign-out-alt ${className || ''}`}></i>);

export const IconArrowDown = ({ className }) => (<i className={`fi fi-rr-arrow-alt-circle-down ${className || ''}`}></i>); // Distinct from chevron
export const IconArrowUp = ({ className }) => (<i className={`fi fi-rr-arrow-alt-circle-up ${className || ''}`}></i>); // Distinct from chevron

export const IconGift = ({ className }) => (<i className={`fi fi-rr-gift ${className || ''}`}></i>);
export const IconTag = ({ className }) => (<i className={`fi fi-rr-tag ${className || ''}`}></i>); // Kept IconTag, assuming IconTagSimple was an alternative
export const IconTagSimple = ({ className }) => (<i className={`fi fi-rr-tag ${className || ''}`}></i>); // Pointing to same as IconTag

export const IconClock = ({ className }) => (<i className={`fi fi-rr-clock ${className || ''}`}></i>);
export const TrashIcon = ({ className }) => (<i className={`fi fi-rr-trash ${className || ''}`}></i>);
export const IconPackage = ({ className }) => (<i className={`fi fi-rr-box-alt ${className || ''}`}></i>);
export const IconTruck = ({ className }) => (<i className={`fi fi-rr-truck-side ${className || ''}`}></i>);
export const IconCheckCircle = ({ className }) => (<i className={`fi fi-rr-check-circle ${className || ''}`}></i>);

export const IconHandsHeart = ({ className }) => (
    <i className={`fi fi-rr-hands-heart ${className || ''}`}></i>
);

export const IconCalculatorMoney = ({ className }) => (
    <i className={`fi fi-rr-calculator-money ${className || ''}`}></i>
);

export const IconEye = ({ className }) => (<i className={`fi fi-rr-eye ${className || ''}`}></i>);
export const IconEyeSlash = ({ className }) => (<i className={`fi fi-rr-eye-crossed ${className || ''}`}></i>);
export const IconMapPin = ({ className }) => (<i className={`fi fi-rr-marker ${className || ''}`}></i>);

/** Zikir / dhikr - remembrance (tasbih counter) */
export const IconZikir = ({ className }) => (<i className={`fi fi-rr-sun ${className || ''}`}></i>);

/** Doa - Islamic prayers & dzikir (book-open-reader = reading prayers) */
export const IconDoa = ({ className }) => (<i className={`fi fi-rr-book-open-reader ${className || ''}`}></i>);

/** Kibla / Qibla - compass direction to Kaaba */
export const IconKibla = ({ className }) => (<i className={`fi fi-rr-compass-alt ${className || ''}`}></i>);

/** Event / calendar */
export const IconEvent = ({ className }) => (<i className={`fi fi-rr-calendar ${className || ''}`}></i>);

/** Ticket / event ticket (using gift icon as ticket metaphor) */
export const IconTicket = ({ className }) => (<i className={`fi fi-rr-gift ${className || ''}`}></i>);

/** Filter / sort */
export const IconFilter = ({ className }) => (<i className={`fi fi-rr-filter ${className || ''}`}></i>);
